(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ReporteEvaluativoMixtoPIIController', ReporteEvaluativoMixtoPIIController);

    ReporteEvaluativoMixtoPIIController.$inject = ['$scope', '$state', '$stateParams','ReporteEvaluativoMixtoPIIService', 'ReporteEvaluativoMixtoPIIRegenerarService','ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'LoginService','entity'
    	];

    function ReporteEvaluativoMixtoPIIController ($scope, $state, $stateParams,ReporteEvaluativoMixtoPIIService, ReporteEvaluativoMixtoPIIRegenerarService,ParseLinks, AlertService, pagingParams, paginationConstants,LoginService,entity
    		) {
        var vm = this;
        vm.reporte=entity.reporte;
        vm.wrapper=entity;
        vm.tipo=entity.tipo;
        vm.round=round;
        vm.save=save;
        vm.autoheight=autoheight;
        vm.print=print;
        
		
		function calculateContentHeight( ta, scanAmount ) {
		    var origHeight = ta.style.height,
		        height = ta.offsetHeight,
		        scrollHeight = ta.scrollHeight,
		        overflow = ta.style.overflow;
		    /// only bother if the ta is bigger than content
		    if ( height >= scrollHeight ) {
		        /// check that our browser supports changing dimension
		        /// calculations mid-way through a function call...
		        ta.style.height = (height + scanAmount) + 'px';
		        /// because the scrollbar can cause calculation problems
		        ta.style.overflow = 'hidden';
		        /// by checking that scrollHeight has updated
		        if ( scrollHeight < ta.scrollHeight ) {
		            /// now try and scan the ta's height downwards
		            /// until scrollHeight becomes larger than height
		            while (ta.offsetHeight >= ta.scrollHeight) {
		                ta.style.height = (height -= scanAmount)+'px';
		            }
		            /// be more specific to get the exact height
		            while (ta.offsetHeight < ta.scrollHeight) {
		                ta.style.height = (height++)+'px';
		            }
		            /// reset the ta back to it's original height
		            ta.style.height = origHeight;
		            /// put the overflow back
		            ta.style.overflow = overflow;
		            return height;
		        }
		    } else {
		        return scrollHeight;
		    }
		}
		
		function autoheight(element) {
			var rows = 1;
			var ta = document.getElementById(element),
			style = (window.getComputedStyle) ?
			window.getComputedStyle(ta) : ta.currentStyle,
			
			// This will get the line-height only if it is set in the css,
			// otherwise it's "normal"
			taLineHeight = parseInt(style.lineHeight, 10),
			// Get the scroll height of the textarea
			taHeight = calculateContentHeight(ta, taLineHeight),
			// calculate the number of lines
			rows = Math.ceil(taHeight / taLineHeight);
			return rows;
		}
		
		
		
        function round(valor){
        	return Math.round(valor);
        }
        
        function print(){
        	window.print();
        }
        
        function save(){
        	 vm.isSaving = true;
        	 if(vm.wrapper.regenerar){
        		 ReporteEvaluativoMixtoPIIRegenerarService.update(vm.wrapper, onSaveSuccess, onSaveError).
               	 $promise.then(function(result){
            		 vm.wrapper.reporte=result;
            	 });
        	 }else{
        		 if (vm.wrapper.reporte.id !== null) {
                	 ReporteEvaluativoMixtoPIIService.update(vm.wrapper, onSaveSuccess, onSaveError).
                   	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 } else {
                	 ReporteEvaluativoMixtoPIIService.save(vm.wrapper, onSaveSuccess, onSaveError).
                	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 }
        	 }
        }
		
        function onSaveSuccess (result) {
            $scope.$emit('sideApp:reporte', result);
            vm.isSaving = false;
			if(vm.wrapper.tipoUser==1){
				 $state.go('generarReporteMixtoPII', 
					{
					 	idA: $stateParams.idA,
			 			idP: $stateParams.idP,
			 			idAnio: $stateParams.idAnio,
			 			idIndice: $stateParams.idIndice,
			 			ic: $stateParams.ic,
			            iic: $stateParams.iic,
			 			tipoEvaluacion: $stateParams.tipoEvaluacion,
			 			idDependencia: $stateParams.idDependencia,
			 			nivell: $stateParams.nivell,
			 			modeloo: $stateParams.modeloo,
						grupo: $stateParams.grupo
					},
					{ reload: true });
			}else{
				if(vm.wrapper.tipoUser==2){
			        $state.go('revisionReporteMixtoPII', null, { reload: true });
			    }
			}	
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
        Highcharts.setOptions({
            chart: {
                backgroundColor: {
                    linearGradient: [0, 0, 500, 500],
                    stops: [
                        [0, 'rgb(255, 255, 255)'],
                        [1, 'rgb(255, 255, 255)']
                        ]
                },
                borderWidth: 2,
                plotBackgroundColor: 'rgba(255, 255, 255, .9)',
                plotShadow: true,
                plotBorderWidth: 1
            }
        });
        
        var chart1 = new Highcharts.Chart({
            chart: {
                renderTo: 'iteraccion1',
    			type: 'bar'
            },
            title: {
                text: ''
            },
			yAxis: {
				title: {
			    	text: ''
			    }
			},
            xAxis: {
            	categories: 
            	[
					'Muestra respeto al dirigirse hacia sus estudiantes.',
					'Muestra respeto hacia la institución.',
					'Promueve un ambiente inclusivo, libre de violencia y discriminación.'
            	],
                type: 'integer'
            },
			tooltip: {
			    valueSuffix: '%'
			},
			plotOptions: {
			    bar: {
			        dataLabels: {
			            enabled: true,
						format: '{y}%'
			        }
			    },
			},
			series: 
			[
			    {
			         name: 'Estudiantes',
			         data: [
			            Math.round(vm.reporte.muestrarespest_e),
			         	Math.round(vm.reporte.muestrarespintitu_e), 
			         	Math.round(vm.reporte.promueveinclulibreviodisc_e)
			            ],
			        	color: '#002e5f'
			     }
			]
        });

        var chart2 = new Highcharts.Chart({
            chart: {
                renderTo: 'iteraccion2',
    			type: 'bar'
            },
            title: {
                text: ''
            },
			yAxis: {
				title: {
			    	text: ''
			    }
			},
            xAxis: {
            	categories: [
					'Fomenta la participación de sus estudiantes en clase.',
					'Guía a sus estudiantes a identificar sus necesidades'
            		],
                type: 'integer'
            },
			tooltip: {
			    valueSuffix: '%'
			},
			plotOptions: {
			    bar: {
			        dataLabels: {
			            enabled: true,
						format: '{y}%'
			        }
			    },
			},
            series: 
			[
				{
                	name: 'Estudiantes',
	                data: [
						Math.round(vm.reporte.fomentapartiestclase_e),
	                	Math.round(vm.reporte.guiaestidennece_e)
					],
	               	color: '#002e5f'
				}, 
				{
					name: 'Autoevaluación',
					data: [
						Math.round(vm.reporte.fomentapartiestclase_p),
						Math.round(vm.reporte.guiaestidennece_p)
					],
					color: '#ffb60f'
				}
			]
        });
        var chart3 = new Highcharts.Chart({
            chart: {
                renderTo: 'estrategias1',
    			type: 'bar'
            },
            title: {
                text: ''
            },
			yAxis: {
				title: {
			    	text: ''
			    }
			},
            xAxis: {
            	categories: 
            	[
					'Inicia sus clases puntualmente.',
					'Optimiza el tiempo de las sesiones presenciales para el logro de los aprendizajes.'
            	],
                type: 'integer'
            },
			tooltip: {
				valueSuffix: '%'
			},
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true,
						format: '{y}%'
                    }
                },
            },
            series: 
			[
				{
	                name: 'Estudiantes',
	                data: 
	                [
						vm.reporte.iniclaspuntual_e,
						vm.reporte.optitiempresenaprend_e
	                ],
	               	color: '#002e5f'
            	}
			]
        });
		var chart4 = new Highcharts.Chart({
		    chart: {
		        renderTo: 'estrategias2',
				type: 'bar'
		    },
		    title: {
		        text: ''
		    },
			yAxis: {
				title: {
			    	text: ''
			    }
			},
		    xAxis: {
		    	categories: [
					'Brinda lineamientos y estrategias para evitar el plagio.',
					'Brinda una inducción al curso PII al inicio del período.',
					'Desarrolla sus sesiones presenciales en inglés.',
					'Informa a sus estudiantes sobre las fechas de corte para las actividades de aprendizaje y pruebas de desempeño.',
					'Ofrece recursos para aprender de manera independiente.',
					'Resuelve dudas respecto a las actividades y los contenidos abordados.',
					'Utiliza actividades de aprendizaje que contribuyen al desarrollo de las competencias (comprensión auditiva y lectora, producción oral y escrita).',
					'Utiliza actividades donde se integran los conocimientos previos y los nuevos.',
					'Utiliza actividades que promueven el interés del estudiantado hacia el aprendizaje del idioma.'
		    		],
		        type: 'integer'
		    },
			tooltip: {
			    valueSuffix: '%'
			},
			plotOptions: {
			    bar: {
			        dataLabels: {
			            enabled: true,
						format: '{y}%'
			        }
			    },
			},
		    series: 
			[
				{
		        	name: 'Estudiantes',
		            data: [
						Math.round(vm.reporte.brindalineestrevplag_e),
						Math.round(vm.reporte.brindaitropii_e),
						Math.round(vm.reporte.dessesipreseningles_e),
						Math.round(vm.reporte.infofechaactspru_e),
						Math.round(vm.reporte.ofrecrecurindepen_e),
						Math.round(vm.reporte.resududasacti_e),
						Math.round(vm.reporte.utilactiaprendesacompe_e),
						Math.round(vm.reporte.utiactconoprevnuev_e),
						Math.round(vm.reporte.utiactprointeres_e)
					],
		           	color: '#002e5f'
				}, 
				{
					name: 'Autoevaluación',
					data: [
						Math.round(vm.reporte.brindalineestrevplag_p),
						Math.round(vm.reporte.brindaitropii_p),
						Math.round(vm.reporte.dessesipreseningles_p),
						Math.round(vm.reporte.infofechaactspru_p),
						Math.round(vm.reporte.ofrecrecurindepen_p),
						Math.round(vm.reporte.resududasacti_p),
						Math.round(vm.reporte.utilactiaprendesacompe_p),
						Math.round(vm.reporte.utiactconoprevnuev_p),
						Math.round(vm.reporte.utiactprointeres_p)
					],
					color: '#ffb60f'
				}
			]
		});
		var chart5 = new Highcharts.Chart({
		    chart: {
		        renderTo: 'estrategias3',
		        type: 'bar'
		    },
		    title: {
		        text: ''
		    },
		    yAxis: {
		        title: {
		            text: ''
		        }
		    },
		    xAxis: {
		        categories: [
					'Informa la puntuación obtenida en cada una de las estrategias de evaluación.',
					'Retroalimenta en tiempo y forma el progreso académico de cada estudiante para que identifique sus fortalezas y debilidades.'
		            ],
		        type: 'integer'
		    },
		    tooltip: {
		        valueSuffix: '%'
		    },
		    plotOptions: {
		        bar: {
		            dataLabels: {
		                enabled: true,
		                format: '{y}%'
		            }
		        },
		    },
		    series: 
		    [
		        {
		            name: 'Estudiantes',
		            data: [
		                Math.round(vm.reporte.infopuntuestrev_e),
		                Math.round(vm.reporte.retrotiemfor_e)
		            ],
		            color: '#002e5f'
		        }, 
		        {
		            name: 'Autoevaluación',
		            data: [
		                Math.round(vm.reporte.infopuntuestrev_p),
		                Math.round(vm.reporte.retrotiemfor_p)
		            ],
		            color: '#ffb60f'
		        }
		    ]
		});
    }
})();
